import type { FC } from 'react';
import React, { useMemo } from 'react';

import type { TBanner } from './models';

export const MenuBanner: FC<TBanner> = ({
    Button,
    DataLayer,
    Link,
    NamedContainer,
    PromoCard,
    Text,
    analytics,
    backgroundUrl,
    bannerLink,
    buttonText,
    buttonView = 'primary',
    buttonlink,
    subtitle,
    theme,
    title,
}) => {
    const promoCardRender = useMemo(
        () => (
            <PromoCard
                background={backgroundUrl}
                height="290px"
                hoverEffect={!!bannerLink}
                width="269px"
            >
                <NamedContainer name="title">
                    <Text styler={{ margin: 0 }} theme={theme} view="small">
                        {title}
                    </Text>
                    {subtitle && (
                        <Text styler={{ marginTop: 16 }} theme={theme} view="primary-medium">
                            {subtitle}
                        </Text>
                    )}
                </NamedContainer>
                <NamedContainer name="buttons">
                    <Button
                        borderRadius={8}
                        href={bannerLink ? undefined : buttonlink}
                        nowrap
                        size="xxs"
                        view={buttonView}
                    >
                        {buttonText}
                    </Button>
                </NamedContainer>
            </PromoCard>
        ),
        [
            PromoCard,
            NamedContainer,
            Text,
            Button,
            backgroundUrl,
            bannerLink,
            buttonView,
            buttonText,
            buttonlink,
            subtitle,
            theme,
            title,
        ]
    );

    const promoCardWithLinkRender = useMemo(() => {
        if (bannerLink) {
            return (
                <Link dataTestId="promo-card-link" href={bannerLink}>
                    {promoCardRender}
                </Link>
            );
        } else {
            return promoCardRender;
        }
    }, [Link, bannerLink, promoCardRender]);

    return <DataLayer analytics={analytics}>{promoCardWithLinkRender}</DataLayer>;
};
